/**
 * iOS doesn't shrink the layout viewport (or `dvh`) for the on-screen keyboard: fixed elements at
 * the bottom end up behind it. This mirrors the visual viewport into CSS so bottom sheets can sit on
 * top of the keyboard: `--keyboard-inset` (layout-viewport height hidden below the visible area) and
 * `--visual-height` (the visible height). Both are 0 / 100dvh-equivalent without a keyboard.
 */
export function watchKeyboard(): void {
  const vv = window.visualViewport;
  if (!vv) return;
  const root = document.documentElement;
  let frame = 0;
  const update = () => {
    frame = 0;
    const inset = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    root.style.setProperty('--keyboard-inset', `${inset}px`);
    root.style.setProperty('--visual-height', `${Math.round(vv.height)}px`);
    root.toggleAttribute('data-keyboard', inset > 80);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  vv.addEventListener('resize', schedule);
  vv.addEventListener('scroll', schedule);
  update();
}
